import { render, staticRenderFns } from "./PackageHeader.vue?vue&type=template&id=32a08ee2&scoped=true&"
import script from "./PackageHeader.vue?vue&type=script&lang=js&"
export * from "./PackageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PackageHeader.vue?vue&type=style&index=0&id=32a08ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a08ee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
